import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import { useState, useEffect, useMemo, useCallback } from 'react';
import { GeoreferenceWrapper, MapPanel, MapPanelBody, MapPanelHeader, MapPanelLeft, BuildingProgress, PropertiesPanel, PropertiesPanelHeader, PropertiesPanelBody, } from './georeference.styled';
import Select from '../../components/common/Select';
import { Button, Flex, Slider, Space, } from 'antd';
import Title from '../../components/common/Title';
import Icon from '../../components/common/Icon';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFloorAction, setBaseFloorFeaturesAction, setBaseFloorLevel, setMapRotationAction, setBaseFloor, setOtherFloor, } from '../../store/floorSlice';
import { checkMapExistsAction } from '../../store/siteSlice';
//@ts-ignore
import DeckGL from '@deck.gl/react';
import { Map } from 'react-map-gl/maplibre';
//@ts-ignore
import { BitmapLayer } from '@deck.gl/layers';
import { EditableGeoJsonLayer } from '@nebula.gl/layers';
import { TransformMode } from '@nebula.gl/edit-modes';
import { _publishSite, _updateFloorGeoreference, } from '../..//shared/httpservice/apis';
// import 'maplibre-gl/dist/maplibre-gl.css';
const floorOptions = [
    { value: 'groundfloor', label: 'Ground Floor' },
    { value: 'firstfloor', label: 'First Floor' },
    { value: 'secondfloor', label: 'Second Floor' },
    { value: 'thirdfloor', label: 'Third Floor' },
    { value: 'fourthfloor', label: 'Fourth Floor' },
];
const GeoreferenceMapView = () => {
    const formatter = value => `${value}%`;
    const [inputValue, setInputValue] = useState(100);
    const onOpacityChange = (value) => {
        setOpacity(value / 100);
        setInputValue(value);
    };
    const query = location.search;
    const url = new URLSearchParams(query);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const floorInfo = useSelector((state) => state?.floors?.getFloor?.response?.data?.content);
    const siteLat = useSelector((state) => state?.site?.checkSite?.response?.data?.latitude);
    const siteLng = useSelector((state) => state?.site?.checkSite?.response?.data?.longitude);
    const mapId = useSelector((state) => state?.auth?.mapId);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        if (url?.size > 0 && mapId) {
            const buildingId = url?.get('buildingId');
            if (buildingId) {
                dispatch(checkMapExistsAction(mapId)).then(res => {
                    if (siteId) {
                        dispatch(getFloorAction({
                            siteId,
                            data: { buildingId: buildingId, pageSize: 50 },
                        }));
                    }
                });
            }
        }
        else {
        }
    }, []);
    //map functions
    const [selectOptions, setSelectOptions] = useState();
    const [selectedFloorValue, setSelectedFloorValue] = useState(0);
    const [imageWidthPixels, setImageWidthPixels] = useState(0); // Define the image width in pixels
    const [imageHeightPixels, setImageHeightPixels] = useState(0); // Define the image height in pixels
    useEffect(() => {
        const options = floorInfo?.map(item => {
            return {
                value: item?.elevation,
                label: `Level (${item?.elevation})`,
            };
        });
        setSelectOptions(options);
    }, [floorInfo]);
    const [selectedfloor, setSelectedFloor] = useState();
    useEffect(() => {
        if (floorInfo) {
            const groundFloor = floorInfo?.find((item) => item?.elevation === selectedFloorValue);
            setImageHeightPixels(groundFloor?.height);
            setImageWidthPixels(groundFloor?.width);
            setSelectedFloor(groundFloor?.imageUrl);
        }
    }, [floorInfo, selectedFloorValue]);
    function createFeatureCollectionFromBounds(bounds) {
        const [minLat, maxLat, minLng, maxLng] = bounds;
        //calculated coordinates
        {
            /**  [maxLng, minLat], // Southeast (SE)
                [minLng, minLat], // Southwest (SW)
                [minLng, maxLat], // Northwest (NW)
                [maxLng, maxLat], // Northeast (NE)
                [maxLng, maxLat], // Northeast (NE) ***/
        }
        //SW, NW, NE, SE, SW
        const polygonCoordinates = [
            [
                [maxLng, minLat],
                [minLng, minLat],
                [minLng, maxLat],
                [maxLng, maxLat],
                [maxLng, maxLat], // Northeast (NE)
            ],
        ];
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: polygonCoordinates,
                    },
                },
            ],
        };
    }
    const bounds = [10.0066539, 10.0084306, 76.3634548, 76.3648511]; // Proper bounds of the image
    // const featureCollection = createFeatureCollectionFromBounds(bounds);
    //polygon from center
    // Convert pixels to meters at zoom level 18
    const pixelToMeters = pixels => pixels * 0.597; // Rough estimate: 1 pixel ~ 0.597 meters at zoom level 18
    // Function to create a polygon based on center coordinates and image dimensions in pixels
    function createPolygonFromImageDimensions(center, widthPixels, heightPixels) {
        const [centerLng, centerLat] = center;
        // 1 degree of latitude is approximately 111 km
        const latPerMeter = 1 / 111320; // Convert meters to degrees latitude
        const lngPerMeter = 1 / (111320 * Math.cos(centerLat * (Math.PI / 180))); // Convert meters to degrees longitude
        // Convert width and height in pixels to meters
        const widthInMeters = pixelToMeters(widthPixels);
        const heightInMeters = pixelToMeters(heightPixels);
        // Calculate half width and half height in degrees
        const halfWidthInDegrees = (widthInMeters / 4) * lngPerMeter;
        const halfHeightInDegrees = (heightInMeters / 4) * latPerMeter;
        const SW = [
            centerLng - halfWidthInDegrees,
            centerLat - halfHeightInDegrees,
        ]; // Southwest (SW)
        const SE = [
            centerLng + halfWidthInDegrees,
            centerLat - halfHeightInDegrees,
        ]; // Southeast (SE)
        const NE = [
            centerLng + halfWidthInDegrees,
            centerLat + halfHeightInDegrees,
        ]; // Northeast (NE)
        const NW = [
            centerLng - halfWidthInDegrees,
            centerLat + halfHeightInDegrees,
        ]; // Northwest (NW)
        // Define the polygon corners relative to the center
        const polygonCoordinates = [
            [
                SW,
                NW,
                NE,
                SE,
                SW, // Close the polygon back to the Southwest
            ],
        ];
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: polygonCoordinates,
                    },
                },
            ],
        };
    }
    const center = [siteLng ? siteLng : 0, siteLat ? siteLat : 0]; // Image center
    useEffect(() => {
        if (center && imageWidthPixels && imageHeightPixels) {
            const featureCollection = createPolygonFromImageDimensions(center, imageWidthPixels / 2, imageHeightPixels / 2);
            setData(featureCollection);
        }
    }, [floorInfo, selectedfloor]);
    const initialViewState = {
        longitude: siteLng ? siteLng : 0,
        latitude: siteLat ? siteLat : 0,
        zoom: 17.5,
        bearing: 0,
        pitch: 0,
    };
    const [data, setData] = useState();
    const [opacity, setOpacity] = useState(0.8);
    const [mode, setMode] = useState(new TransformMode());
    const [rotation, setRotation] = useState(0); // Store the current rotation of the image  
    const [viewState, setViewState] = useState(initialViewState);
    const [eyeClick, setEyeClick] = useState(false);
    useEffect(() => {
        if (siteLat && siteLng) {
            setViewState({
                longitude: siteLng ? siteLng : 0,
                latitude: siteLat ? siteLat : 0,
                zoom: 17.5,
                bearing: 0,
                pitch: 0,
            });
        }
    }, [siteLat, siteLng]);
    const [originalPolygon, setOriginalPolygon] = useState(null);
    useEffect(() => {
        if (data && !originalPolygon) {
            const initialPolygon = data.features[0].geometry.coordinates[0];
            setOriginalPolygon(initialPolygon); // Save the initial polygon
        }
    }, [data]);
    //@ts-ignore
    const handleEdit = ({ updatedData }) => {
        const newPolygon = updatedData.features[0].geometry.coordinates[0];
        if (originalPolygon) {
            // Calculate angle for original and updated polygons
            const [originalP1, originalP2] = [originalPolygon[0], originalPolygon[1]]; // Top-left and top-right of the original polygon
            const [newP1, newP2] = [newPolygon[0], newPolygon[1]]; // Top-left and top-right of the updated polygon
            // Angle of original polygon
            const originalAngle = Math.atan2(originalP2[1] - originalP1[1], originalP2[0] - originalP1[0]);
            // Angle of updated polygon
            const newAngle = Math.atan2(newP2[1] - newP1[1], newP2[0] - newP1[0]);
            // Relative rotation angle in degrees
            const relativeRotation = ((newAngle - originalAngle) * 180) / Math.PI;
            setRotation(relativeRotation); // Update the rotation state
        }
        setData(updatedData); // Update the GeoJSON with transformed data
    };
    const geoJson = {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        [
                            [76.3634548, 10.0084306],
                            [76.36431453891487, 10.0084306],
                            [76.36431453981879, 10.007336638723649],
                            [76.3634548, 10.007336638723649],
                            [76.3634548, 10.0084306], // Closing point (top-left)
                        ],
                    ],
                },
            },
        ],
    };
    function convertToGeoReferences(geoJson) {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        // Extract points
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        // Create geoReferences array
        const geoReferences = [
            {
                control: { x: topLeft[0], y: topLeft[1] },
                target: { x: 0, y: 0 },
            },
            {
                control: { x: bottomLeft[0], y: bottomLeft[1] },
                target: {
                    x: Math.abs(bottomLeft[0] - bottomRight[0]),
                    y: Math.abs(bottomLeft[1] - bottomRight[1]),
                },
            },
            {
                control: { x: bottomRight[0], y: bottomRight[1] },
                target: {
                    x: Math.abs(bottomRight[0] - bottomLeft[0]),
                    y: 0,
                },
            },
            {
                control: { x: topRight[0], y: topRight[1] },
                target: {
                    x: Math.abs(topRight[0] - topLeft[0]),
                    y: Math.abs(topRight[1] - topLeft[1]),
                },
            },
        ];
        return geoReferences;
    }
    const generateHeight = (geoJson) => {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        const height = Math.abs(bottomLeft[0] - topLeft[0]);
        return height;
    };
    const generateWidth = (geoJson) => {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        const width = Math.abs(topRight[1] - topLeft[1]);
        return width;
    };
    const geoReferences = convertToGeoReferences(geoJson);
    const completeBaseFloorPlacement = () => {
        const baseFloor = floorInfo?.find((item) => item?.elevation === selectedFloorValue);
        const otherFloors = floorInfo?.filter((item) => item?.elevation !== selectedFloorValue);
        dispatch(setBaseFloorFeaturesAction(data));
        dispatch(setMapRotationAction(-rotation));
        dispatch(setBaseFloorLevel(selectedFloorValue));
        dispatch(setBaseFloor(baseFloor));
        dispatch(setOtherFloor(otherFloors));
        try {
            const floorId = floorInfo?.find((item) => item?.elevation === selectedFloorValue);
            const coordinates = convertToGeoReferences(data);
            const height = generateHeight(data);
            const width = generateWidth(data);
            if (siteId && floorId) {
                return _updateFloorGeoreference(coordinates, siteId, floorId?.floorId, -rotation).then(() => {
                    navigate('/floor-align');
                });
            }
        }
        catch (error) {
        }
    };
    const finishAlignment = () => {
        try {
            const floorId = floorInfo?.find((item) => item?.elevation === selectedFloorValue);
            const coordinates = convertToGeoReferences(data);
            const height = generateHeight(data);
            const width = generateWidth(data);
            if (siteId && floorId) {
                return _updateFloorGeoreference(coordinates, siteId, floorId?.floorId, -rotation).then(() => {
                    dispatch(setMapRotationAction(-rotation));
                    return _publishSite(siteId).then(res => {
                        if (res) {
                            navigate({
                                pathname: "/editor",
                                search: 'panel=mapping'
                            });
                        }
                    });
                });
            }
        }
        catch (error) {
        }
    };
    useEffect(() => {
        if (eyeClick) {
            setOpacity(0);
        }
        else {
            setOpacity(inputValue);
        }
    }, [eyeClick]);
    const ZOOM_STEP = 0.5;
    // Zoom handler
    const handleZoom = useCallback((zoomIn) => {
        setViewState(current => ({
            ...current,
            zoom: Math.max(0, Math.min(20, current.zoom + (zoomIn ? ZOOM_STEP : -ZOOM_STEP))),
            transitionDuration: 200,
        }));
    }, []);
    const ROTATION_STEP = 15; // Define the rotation step in degrees
    // Rotation handler
    const handleRotation = useCallback((clockwise) => {
        setViewState((current) => ({
            ...current,
            bearing: (current.bearing + (clockwise ? ROTATION_STEP : -ROTATION_STEP)) % 360,
            transitionDuration: 200,
        }));
    }, []);
    const layers = useMemo(() => {
        if (!data)
            return [];
        return [
            new BitmapLayer({
                id: 'bitmap-layer',
                bounds: data?.features[0]?.geometry?.coordinates[0] || [],
                image: selectedfloor || '',
                opacity,
            }),
            new EditableGeoJsonLayer({
                id: 'editable-layer',
                data,
                mode,
                selectedFeatureIndexes: [0],
                onEdit: handleEdit,
                getEditHandlePointColor: () => [0, 0, 255, 200],
                editHandlePointRadiusMinPixels: 5,
                editHandlePointRadiusMaxPixels: 10,
                getEditHandlePointOutlineColor: () => [0, 0, 2, 2],
                getEditHandlePointOutlineWidth: 2,
                getFillColor: () => [0, 0, 0, 0],
                getLineColor: () => [0, 0, 0, 0],
                getLineWidth: () => 0,
            })
        ];
    }, [data, opacity, rotation, selectedfloor]);
    return (_jsxs(GeoreferenceWrapper, { children: [_jsx(DeckGL, { initialViewState: viewState, controller: true,
                //@ts-ignore
                onViewStateChange: ({ viewState }) => setViewState(viewState), layers: layers, getCursor: () => 'pointer', children: _jsx(Map, { mapStyle: "https://beco-lightning-backend.s3.ap-southeast-1.amazonaws.com/styles/style.json" }) }), _jsxs("div", { className: "ol-zoom", style: {
                    bottom: "40px"
                }, children: [_jsx(Button, { onClick: () => handleZoom(true), className: "ol-zoom-in", "aria-label": "Zoom in", children: "+" }), _jsx(Button, { onClick: () => handleZoom(false), className: "ol-zoom-out", "aria-label": "Zoom out", children: "-" })] }), _jsxs("div", { className: "ol-zoom", style: {
                    bottom: "120px"
                }, children: [_jsx(Button, { onClick: () => handleRotation(false), className: "rotate-btn", "aria-label": "Rotate left", children: "\u27F2" }), _jsx(Button, { onClick: () => handleRotation(true), className: "rotate-btn", "aria-label": "Rotate right", children: "\u27F3" })] }), _jsx(MapPanel, { title: _jsxs(MapPanelHeader, { children: [_jsxs("div", { children: [_jsx(Title, { text: "Building 1", level: 4, fontWeight: 600 }), _jsx(BuildingProgress, { percent: 30 })] }), _jsx(Space, { children: _jsx(Button, { size: "small", disabled: true, children: "Next" }) })] }), actions: [
                    _jsx(Flex, { style: { marginRight: '12px' }, align: "center", justify: "flex-end", children: floorInfo && floorInfo?.length > 1 ? (_jsx(Button, { onClick: () => {
                                completeBaseFloorPlacement();
                            }, color: "default", variant: "solid", children: "Next" })) : (_jsx(Button, { onClick: () => {
                                finishAlignment();
                            }, color: "default", variant: "solid", children: "Finish" })) }),
                ], children: _jsx(MapPanelBody, { children: _jsxs(MapPanelLeft, { children: [_jsx(Select, { variant: 'filled', options: selectOptions, onChange: setSelectedFloorValue, value: selectedFloorValue }), _jsxs(PropertiesPanel, { border: true, children: [_jsxs(PropertiesPanelHeader, { children: [_jsx("label", { children: "Opacity" }), _jsx(Icon, { onClick: () => {
                                                    setEyeClick(!eyeClick);
                                                }, icon: eyeClick ? "eye-off" : "eye", size: 18 })] }), _jsxs(PropertiesPanelBody, { children: [_jsx(Slider, { min: 0, max: 100, tooltip: { formatter }, onChange: onOpacityChange, value: typeof inputValue === 'number' ? inputValue : 0 }), _jsxs("span", { children: [inputValue, "%"] })] })] })] }) }) })] }));
};
export default GeoreferenceMapView;
